export default function Card({ children, className = '', delay = 0 }) {
  return (
    <div
      className={`bg-mm-card border border-mm-border rounded-xl p-6 animate-fade-up ${className}`}
      style={{ animationDelay: `${delay}s` }}
    >
      {children}
    </div>
  )
}

export function CardHeader({ title, badge, badgeVariant = 'sage' }) {
  const badgeColors = {
    sage: 'text-mm-sage bg-mm-sage/10 border-mm-sage/25',
    persimmon: 'text-mm-persimmon bg-mm-persimmon/10 border-mm-persimmon/25',
    gold: 'text-mm-gold bg-mm-gold/10 border-mm-gold/25',
    viridian: 'text-mm-viridian bg-mm-viridian/10 border-mm-viridian/25',
  }

  return (
    <div className="flex items-center justify-between mb-5">
      <h3 className="text-[13px] font-glacial-bold uppercase tracking-wider text-mm-gold">
        {title}
      </h3>
      {badge && (
        <span className={`text-[11px] px-2.5 py-0.5 rounded border ${badgeColors[badgeVariant]}`}>
          {badge}
        </span>
      )}
    </div>
  )
}
